import { apiClient } from '../http'

/**
 * Сервис для работы с аутентификацией
 */
export const authService = {
    async telegramAuth({ initData, siteId }) {
        console.log('🔍 Отправляем запрос авторизации:', {
            hasInitData: !!initData,
            siteId,
            baseURL: apiClient.defaults.baseURL,
        })
        const response = await apiClient.post('/auth/telegram', {
            initData,
            siteId,
        })
        console.log('✅ Ответ от сервера:', response.data)
        return response.data
    },

    /**
     * Отправка диагностических логов на сервер
     */
    async diag(event, payload) {
        try {
            await apiClient.post('/diag', { event, payload })
        } catch (e) {}
    },

    /**
     * Обновление токена доступа
     */
    async refreshToken(refreshToken) {
        const response = await apiClient.post('/auth/refresh', { refreshToken })
        return response.data
    },

    /**
     * Получение информации о текущем пользователе
     */
    async getMe() {
        const response = await apiClient.get('/auth/me')
        return response.data
    },

    /**
     * Выход из системы
     */
    async logout() {
        const response = await apiClient.post('/auth/logout')
        return response.data
    },

    /**
     * Синхронизация языка с бэкендом
     * @param {string} languageCode - код языка (en, ru, pl, uk, pt-BR и т.д.)
     */
    async syncLanguage(languageCode) {
        try {
            const response = await apiClient.patch('/auth/language', { languageCode })
            return response.data
        } catch (error) {
            console.warn('Failed to sync language with backend:', error.message)
            return null
        }
    },
}
